package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CompletionReportResponse(
    @SerialName("damage") val damage: Boolean?,
    @SerialName("correctFunctionality") val correctFunctionality: Boolean?,
    @SerialName("additionalNotes") val additionalNotes: String?,
    @SerialName("healthAndSafety") val healthAndSafety: Boolean?,
    @SerialName("clientSignature") val clientSignature: String?,
    @SerialName("clientFeedback") val clientFeedback: String?,
    @SerialName("files") var files: List<String>? = null,
    @SerialName("jobId") val jobId: String,
    @SerialName("workspaceId") val workspaceId: String,
    @SerialName("userId") val userId: String,
    @SerialName("type") val type: String,
    @SerialName("status") val status: String,
    @SerialName("damageDescription") var damageDescription: String? = null,
    @SerialName("reasonForIncompleteInspection") var reasonForIncompleteInspection: String? = null,
    @SerialName("unmetSafetyRequirements") var unmetSafetyRequirements: String? = null
) {
    fun isDifferent(remoteReport: CompletionReportResponse): Boolean {
        val differences = mutableListOf<String>()

        if (this.damage != remoteReport.damage) differences.add("damage: '${this.damage}' vs '${remoteReport.damage}'")
        if (this.correctFunctionality != remoteReport.correctFunctionality) differences.add("correctFunctionality: '${this.correctFunctionality}' vs '${remoteReport.correctFunctionality}'")
        if (this.additionalNotes != remoteReport.additionalNotes) differences.add("additionalNotes: '${this.additionalNotes}' vs '${remoteReport.additionalNotes}'")
        if (this.healthAndSafety != remoteReport.healthAndSafety) differences.add("healthAndSafety: '${this.healthAndSafety}' vs '${remoteReport.healthAndSafety}'")
        if (this.clientSignature != remoteReport.clientSignature) differences.add("clientSignature: '${this.clientSignature}' vs '${remoteReport.clientSignature}'")
        if (this.clientFeedback != remoteReport.clientFeedback) differences.add("clientFeedback: '${this.clientFeedback}' vs '${remoteReport.clientFeedback}'")
        if (this.files != remoteReport.files) differences.add("files: '${this.files}' vs '${remoteReport.files}'")
        if (this.status != remoteReport.status) differences.add("status: '${this.status}' vs '${remoteReport.status}'")
        if (this.damageDescription != remoteReport.damageDescription) differences.add("damageDescription: '${this.damageDescription}' vs '${remoteReport.damageDescription}'")
        if (this.reasonForIncompleteInspection != remoteReport.reasonForIncompleteInspection) differences.add("reasonForIncompleteInspection: '${this.reasonForIncompleteInspection}' vs '${remoteReport.reasonForIncompleteInspection}'")
        if (this.unmetSafetyRequirements != remoteReport.unmetSafetyRequirements) differences.add("unmetSafetyRequirements: '${this.unmetSafetyRequirements}' vs '${remoteReport.unmetSafetyRequirements}'")

        if (differences.isNotEmpty()) {
            println("CompletionReport differences found for job '${this.jobId}':")
            differences.forEach { println("  - $it") }
            return true
        }

        return false
    }
}
